import { Link } from "react-router-dom";
import { useCmsDoc } from "../hooks/useCmsDoc";
import { useCookieConsentOptional } from "../context/CookieConsentContext";
import { defaultLegalDoc } from "../data/legalDefaults";
import { COOKIE_POLICY_VERSION } from "../lib/cookieConsent";

export default function CookiePolicyPage() {
  const { data } = useCmsDoc("site", "legal", defaultLegalDoc());
  const legal = { ...defaultLegalDoc(), ...data };
  const consent = useCookieConsentOptional();
  const sections = legal.cookiesSections?.length
    ? legal.cookiesSections
    : defaultLegalDoc().cookiesSections;
  const matrix = legal.consentMatrix?.length
    ? legal.consentMatrix
    : defaultLegalDoc().consentMatrix;

  return (
    <div className="pt-28 pb-20 bg-surface min-h-screen">
      <article className="container mx-auto px-6 max-w-3xl">
        <p className="text-[10px] font-bold uppercase tracking-widest text-brand-primary mb-3">
          {legal.cookiesTitle}
        </p>
        <h1 className="font-display text-4xl font-black text-brand-dark tracking-tight mb-2">
          {legal.cookiesSubtitle}
        </h1>
        <p className="text-sm text-brand-dark/50 mb-6">
          Última actualización: {legal.cookiesUpdated} · Preferencia técnica v.
          {COOKIE_POLICY_VERSION}
        </p>

        {consent ? (
          <button
            type="button"
            onClick={() => consent.openPreferences()}
            className="mb-10 px-5 py-3 rounded-xl bg-brand-primary text-white text-xs font-bold uppercase tracking-wider"
          >
            Configurar cookies
          </button>
        ) : null}

        <div className="space-y-8 text-sm text-brand-dark/85 leading-relaxed">
          <p className="whitespace-pre-line">{legal.cookiesIntro}</p>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-dark mb-4">
              Con consentimiento / sin consentimiento
            </h2>
            <div className="space-y-4">
              {matrix.map((row) => (
                <div
                  key={row.id || row.label}
                  className="rounded-2xl border border-brand-soft bg-white overflow-hidden"
                >
                  <div className="px-4 py-3 bg-brand-soft/50 font-bold text-brand-dark">
                    {row.label}
                  </div>
                  <div className="grid md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-brand-soft">
                    <div className="p-4 space-y-1">
                      <p className="text-[10px] font-bold uppercase tracking-widest text-brand-primary">
                        Con consentimiento
                      </p>
                      <p className="text-sm text-brand-dark/80 whitespace-pre-line">
                        {row.withConsent}
                      </p>
                    </div>
                    <div className="p-4 space-y-1">
                      <p className="text-[10px] font-bold uppercase tracking-widest text-brand-dark/45">
                        Sin consentimiento
                      </p>
                      <p className="text-sm text-brand-dark/80 whitespace-pre-line">
                        {row.withoutConsent}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {sections.map((sec) => (
            <section key={sec.id || sec.title}>
              <h2 className="font-display text-xl font-bold text-brand-dark mb-2">{sec.title}</h2>
              <p className="whitespace-pre-line">{sec.body}</p>
            </section>
          ))}

          <p>
            Aviso de privacidad:{" "}
            <Link to="/privacidad" className="text-brand-primary font-semibold underline">
              /privacidad
            </Link>
            .
          </p>

          {legal.legalDisclaimer ? (
            <p className="text-xs text-brand-dark/45">{legal.legalDisclaimer}</p>
          ) : null}
        </div>
      </article>
    </div>
  );
}
